var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficialBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_i_4410_7767)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98113 1.66038L12 0L15.0189 1.66038V4.71197L17.1768 2.55408L20.4855 3.51467L21.4461 6.8234L19.2884 8.98113H22.3396L24 12L22.3396 15.0189H19.2886L21.4463 17.1765L20.4857 20.4852L17.1769 21.4458L15.0189 19.2878V22.3396L12 24L8.98113 22.3396V19.2884L6.82365 21.4458L3.51492 20.4852L2.55433 17.1765L4.71197 15.0189H1.66038L0 12L1.66038 8.98113H4.71223L2.5545 6.8234L3.5151 3.51467L6.82383 2.55408L8.98113 4.71138V1.66038Z",
    fill: "url(#paint0_radial_4410_7767)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5082 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9135 8.87339C17.2419 9.25054 17.2152 9.83423 16.854 10.1771L11.3215 15.4284L7.92975 11.328C7.61066 10.9422 7.65151 10.3594 8.02097 10.0263C8.39044 9.69311 8.94862 9.73575 9.2677 10.1215L11.4741 12.789L15.6648 8.81131C16.0261 8.46844 16.5851 8.49624 16.9135 8.87339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4410_7767",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.518386 0 0 0 0 0.605077 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4410_7767"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4410_7767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1348 12.1348) rotate(90.6511) scale(11.8659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE9EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialBadge);
export default __webpack_public_path__ + "static/media/officialBadge.4b9c0dfac1a7c0bf0659438f9a840414.svg";
export { ForwardRef as ReactComponent };